import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import { cn } from 'helpers/classnames';
import useMartyContext from 'hooks/useMartyContext';
import Button from 'components/common/Button';
import { createDeleteAccountMailToLink } from 'helpers/MyAccountUtils';

import css from 'styles/containers/account/deleteAccount.scss';

const DeleteAccount = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');

  const {
    marketplace: { shortName }
  } = useMartyContext();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const mailToLink = createDeleteAccountMailToLink(shortName, name, email);
    if (global.window && mailToLink) {
      window.location.href = mailToLink;
    }
  };

  return (
    <div className="flex flex-col items-center justify-center px-4 text-center text-base">
      <h1 className="text-4xl">Account Deletion Request</h1>
      <p>You are trying to delete your Zappos account. Once approved you will no longer have access to your account or any of Zappos' services.</p>

      <form onSubmit={handleSubmit} method="GET" className="my-8 flex flex-col items-center justify-center">
        <div className={cn(css.formField, 'mb-0')}>
          <input type="text" name="name" id="name" value={name} placeholder="Your Name" onChange={e => setName(e.target.value)} required />
        </div>
        <div className={cn(css.formField, 'mb-0')}>
          <input type="email" name="email" id="email" value={email} placeholder="Your Email" onChange={e => setEmail(e.target.value)} required />
        </div>
        <Button disabled={!name || !email} type="submit" variant="filled">
          Submit
        </Button>
      </form>

      <div className="m-4 flex flex-col items-center justify-center">
        <p>You will be asked for confirmation on the email provided to verify deletion of the account.</p>
        <p>For more information on CCPA, please click the link below.</p>
        <Link to="/c/state-privacy" className="underline underline-offset-4">
          https://www.zappos.com/c/state-privacy
        </Link>
      </div>
    </div>
  );
};

export default DeleteAccount;
